// HTTP клиенты (REST)
import { AuthClient } from "@infrastructure/clients/http/clients/auth.client";
import { UserClient } from "@infrastructure/clients/http/clients/user.client";
import { OrderClient } from "@infrastructure/clients/http/clients/order.client";
import { MachineClient } from "@infrastructure/clients/http/clients/machine.client";
import { ServiceClient } from "@infrastructure/clients/http/clients/service.client";
import { GeoClient } from "@infrastructure/clients/http/clients/geo.client";
import { CreditCardClient } from "@infrastructure/clients/http/clients/creditCard.client";
import { FileClient } from "@infrastructure/clients/http/clients/file.client";
import { FeedbackClient } from "@infrastructure/clients/http/clients/feedback.client";

// WebSocket клиенты
import { NotificationsWebSocketClient } from "@infrastructure/clients/ws/clients/notifications.client";

// SSE клиенты
import { EventsSSEClient } from "@infrastructure/clients/sse/clients/events.client";

// MQTT клиенты
import { IoTMQTTClient } from "@infrastructure/clients/mqtt/clients/iot.client";

// WebRTC клиенты
import { VideoWebRTCClient } from "@infrastructure/clients/webrtc/clients/video.client";

// Polling клиенты
import { UpdatesLongPollingClient, UpdatesShortPollingClient } from "@infrastructure/clients/polling/clients/updates.client";

// HTTP/2 Push клиенты
import { ResourcesHTTP2PushClient } from "@infrastructure/clients/http2-push/clients/resources.client";

export const apiClients = {
  // REST (axios)
  http: {
    auth: new AuthClient(),
    user: new UserClient(),
    order: new OrderClient(),
    machine: new MachineClient(),
    service: new ServiceClient(),
    geo: new GeoClient(),
    creditCard: new CreditCardClient(),
    file: new FileClient(),
    feedback: new FeedbackClient(),
  },

  // WebSocket
  ws: {
    notifications: new NotificationsWebSocketClient(),
  },

  // SSE
  sse: {
    events: new EventsSSEClient(),
  },

  // MQTT
  mqtt: {
    iot: new IoTMQTTClient(),
  },

  // WebRTC
  webrtc: {
    video: new VideoWebRTCClient(),
  },

  // Polling
  polling: {
    long: new UpdatesLongPollingClient(),
    short: new UpdatesShortPollingClient(),
  },

  // HTTP/2 Push
  http2push: {
    resources: new ResourcesHTTP2PushClient(),
  },
};
